
export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 md:px-12">
      <div className="relative z-10 max-w-[1000px] mx-auto text-center">
        <div className="mb-12 animate-fade-in">
          <div className="flex justify-center mb-8">
            <img 
              src="https://static.readdy.ai/image/45ee86dea452076dc7a3c34b683d6864/58f45d3287acfa85158e3b798c03a082.png"
              alt="Bor Ventures Logo"
              className="h-24 md:h-32 w-auto object-contain"
            />
          </div>

          <h1 
            className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6"
            style={{
              fontFamily: "'Orbitron', sans-serif",
              background: 'linear-gradient(135deg, #7C3AED 0%, #00D4FF 50%, #FCD34D 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            Bor Ventures
          </h1>

          <h2 
            className="text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-800 mb-8"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Architecting the Future of the Human-Pet Bond
          </h2>

          <p 
            className="text-base md:text-lg text-gray-700 leading-relaxed max-w-[800px] mx-auto mb-12"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            In an era where pets are family, Bor Ventures invests at the forefront of the pet humanization revolution. We back visionary founders building intelligent, scalable businesses that harness cross-industry innovation and proprietary data to create exponential value — elevating care, connection, and lifestyle with strong fundamentals and enduring potential.
          </p>

          <button
            onClick={() => {
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-10 py-4 text-base md:text-lg font-semibold text-white rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, #7C3AED 0%, #00D4FF 100%)',
              boxShadow: '0 8px 24px rgba(124, 58, 237, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(124, 58, 237, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(124, 58, 237, 0.3)';
            }}
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
}
